const topics = [
  { id: 1, name: '繁花大结局', heat: '89.2万', tag: '爆', color: 'bg-primary-500' },
  { id: 2, name: '科幻电影推荐', heat: '76.5万', tag: '热', color: 'bg-accent-500' },
  { id: 3, name: '古装剧排行榜', heat: '65.8万', tag: '新', color: 'bg-secondary-500' },
  { id: 4, name: '悬疑片精选', heat: '54.3万', tag: '荐', color: 'bg-primary-400' },
  { id: 5, name: '国产动画崛起', heat: '48.9万', tag: '热', color: 'bg-accent-500' },
  { id: 6, name: '高分纪录片', heat: '42.1万', tag: '精', color: 'bg-secondary-500' },
  { id: 7, name: '周星驰经典', heat: '38.7万', tag: '经典', color: 'bg-primary-400' },
  { id: 8, name: '日剧精选合集', heat: '35.2万', tag: '新', color: 'bg-accent-500' },
  { id: 9, name: '港片回顾', heat: '31.6万', tag: '荐', color: 'bg-secondary-500' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全网影视热议，看看大家都在聊什么</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 p-3 md:p-4 rounded-xl bg-background-100 hover:bg-background-200 cursor-pointer transition-colors duration-200"
            >
              <div className={`w-10 h-10 rounded-xl ${topic.color} flex items-center justify-center flex-shrink-0`}>
                <span className="text-white text-xs font-bold whitespace-nowrap">{topic.tag}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                  #{topic.name}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                  <i className="ri-fire-line text-accent-500 mr-1"></i>
                  {topic.heat} 热度
                </p>
              </div>
              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}